import ajax from "@/lib/ajax"

// SavePropaganda
// 【健康宣教-宣教库】-新增或者编辑
export async function SavePropaganda(payload: any){
	let res = await ajax.post('/api/services/app/Propaganda/SavePropaganda', payload)
	return res.data.result
}
// Propaganda/DeletePropaganda
// 【健康宣教-宣教库】-删除
export async function DeletePropaganda(payload: any){
	let res = await ajax.delete('/api/services/app/Propaganda/DeletePropaganda', {params:payload})
	return res.data.result
}
// GetPropaganda
// 【健康宣教-宣教库】-列表
export async function GetPropaganda(payload: any){
	let res = await ajax.get('/api/services/app/Propaganda/GetPropaganda', {params:payload})
	return res.data.result
}
// GetPropagandaPlan
// 【健康宣教-患者宣教计划】-列表
export async function GetPropagandaPlan(payload: any){
	let res = await ajax.get('/api/services/app/Propaganda/GetPropagandaPlan', {params:payload})
	return res.data.result
}
// SavePatPropagandaPlan
// 【宣教信息-宣教计划-计划详情】-新增或者编辑
export async function SavePatPropagandaPlan(payload: any){
	let res = await ajax.post('/api/services/app/Propaganda/SavePatPropagandaPlan', payload)
	return res.data.result
}
// GetPatPropagandaPlan
// 【宣教信息-宣教计划-计划详情】-列表
export async function GetPatPropagandaPlan(payload: any){
	let res = await ajax.get('/api/services/app/Propaganda/GetPatPropagandaPlan', {params:payload})
	return res.data.result
}
// DeletePatPropagandaPlan
// 【宣教信息-宣教计划-计划详情】-删除
export async function DeletePatPropagandaPlan(payload: any){
	let res = await ajax.delete('/api/services/app/Propaganda/DeletePatPropagandaPlan', {params:payload})
	return res.data.result
}
// SavePatEducationEvaluate
// 【宣教信息-宣教计划-计划详情】-评价
export async function SavePatEducationEvaluate(payload: any){
	let res = await ajax.post('/api/services/app/Propaganda/SavePatEducationEvaluate', payload)
	return res.data.result
}
// GetPatEducations
// 【宣教记录】
export async function GetPatEducations(payload: any){
	let res = await ajax.get('/api/services/app/Propaganda/GetPatEducations', {params:payload})
	return res.data.result
}

// GetPatPropagandaPlanHist
// 【宣教信息-宣教计划-计划详情】-宣教计划历史
export async function GetPatPropagandaPlanHist(payload: any){
	let res = await ajax.get('/api/services/app/Propaganda/GetPatPropagandaPlanHist', {params:payload})
	return res.data.result
}

// DlyEduc
// 透析区:【宣教-评估】功能
export async function DlyEduc(payload: any){
	let res = await ajax.post('/api/services/app/Propaganda/DlyEduc', {params:payload})
	return res.data.result
}



// WEBPACK FOOTER //
// ./src/api/propaganda/index.ts